import Image from '../../ui/Image/Image'
import MainButton from '../../ui/MainButton/MainButton'
import s from './BannersCategory.module.css'

type Banner = {
  id: number
  image: string
  title: string
  icon: string
  description: string
  url: string
  style: string
}

export default function BannersCategory({ banners }: { banners: Banner[] }) {
  return (
    <div
      className={`${s.bannersCategory} ${
        banners.length === 3 ? s.threeBanners : banners.length === 2 ? s.twoBanners : ''
      }`}
    >
      {banners.map(banner => (
        <div
          key={banner.id}
          className={`${s.banner} ${banner.style === 'dark' ? s.dark : s.light}`}
        >
          <Image
            src={banner.image}
            alt=""
            sizes="(min-width: 1024px) 40vw, 100vw"
            className={s.bannerPhoto}
          />
          <div className={s.info}>
            <div className={s.headingWrapper}>
              <div className={s.iconCircle}>
                <img src={banner.icon} alt={banner.title} width={20} height={20} />
              </div>
              <h3>{banner.title}</h3>
            </div>
            <p>{banner.description}</p>
          </div>
          <MainButton text="Перейти" style={banner.style} href={banner.url} />
        </div>
      ))}
    </div>
  )
}
